export const GET_ALL_NOTIFICATION = 'get-all-notification'
export const GET_NOTIFICATION_FROM_TELLER = 'get-notification-from-teller'
export const GET_NEWS = 'get-news'
export const UPDATE_MAIN_TAB = 'update-main-tab'
